/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type GetDashboardGraphInterval = (typeof GetDashboardGraphInterval)[keyof typeof GetDashboardGraphInterval];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDashboardGraphInterval = {
  all: "all",
  year: "year",
  half_year: "half_year",
  month: "month",
  week: "week",
} as const;
